export class DisplayException {
    Message:string;
    Type:string;
    Code:number;
    constructor() {
    }
  }